import { css } from 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import Label from 'reakit/Label';
import 'reakit/Input';
import { a as HiddenInput } from '../chunk-2cd0d082.js';
var CheckboxIcon = styled(Box).withConfig({
  displayName: "styled__CheckboxIcon",
  componentId: "sc-1cw8kp1-0"
})(["-webkit-appearance:none;background-color:white;border:1px solid #bdbdbd;box-shadow:inset 0px 1px 2px #e5e5e5;border-radius:0.2em;height:1em;position:relative;margin-top:0.25em;min-width:1em;width:1em;&{", ";}&{", ";}"], function (props) {
  return props.state && css(["border-color:", ";box-shadow:", " 0px 0px 0px 1px !important;"], function (props) {
    return palette("" + props.state)(props);
  }, function (props) {
    return palette("" + props.state)(props);
  });
}, theme('fannypack.Checkbox.base'));
var HiddenCheckbox = HiddenInput({
  Icon: CheckboxIcon,
  checkedIconCss: css(["background-clip:padding-box;content:'';left:calc(50% - 0.1875em);top:calc(50% - 0.375em);position:absolute;&{", ";}"], function (props) {
    return props.indeterminate ? css(["background-color:", ";height:0.125em;width:0.625em;top:calc(50% - 0.0625em);left:calc(50% - 0.3125em);"], palette('primary')) : css(["border:0.1em solid ", ";border-left-width:0;border-top-width:0;height:0.625em;transform:rotate(45deg);width:0.375em;"], palette('primary'));
  }),
  disabledCheckedIconCss: css(["border-color:", ";"], palette('gray300')),
  themePrefix: 'Checkbox'
});
var Checkbox = styled(Label).withConfig({
  displayName: "styled__Checkbox",
  componentId: "sc-1cw8kp1-1"
})(["display:flex;align-items:flex-start;&{", ";}"], theme('fannypack.Checkbox.label'));
export default Checkbox;
export { Checkbox, CheckboxIcon, HiddenCheckbox };